/**
 * What stands in place of the entry fields on an iPhone still running in a
 * Safari tab — ADR-0004 §2.9.
 *
 * The steps are written out because iOS has no install prompt a button could
 * trigger: installing is a manual walk through the share menu. The ADR is
 * explicit that this is done with the site manager in person during
 * onboarding, so this screen is a reminder for somebody who has been shown
 * once, not a substitute for being shown.
 *
 * It says why, not only what. "Dodajte na početni zaslon" without a reason
 * reads as an upsell and gets dismissed; "iPhone briše spremljene unose"
 * is the actual stake.
 */
export function UputaZaInstalaciju() {
  return (
    <section className="avm-surface flex flex-col gap-4 rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-card)] p-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-[var(--text-section)] font-semibold">
          Dodajte aplikaciju na početni zaslon
        </h2>
        <p className="max-w-[52ch] text-[var(--color-muted-foreground)]">
          Unos sati bez mreže radi samo iz aplikacije pokrenute s početnog
          zaslona. Otvorena u Safari kartici, iPhone nakon sedam dana bez
          korištenja obriše spremljene unose — i to se ne bi vidjelo dok ne
          dođe obračun.
        </p>
      </div>

      <ol className="flex flex-col gap-3">
        <Korak broj={1}>
          Dodirnite <strong>Podijeli</strong> u donjoj traci Safarija — kvadrat
          sa strelicom prema gore.
        </Korak>
        <Korak broj={2}>
          Odaberite <strong>Dodaj na početni zaslon</strong>.
        </Korak>
        <Korak broj={3}>
          Potvrdite <strong>Dodaj</strong>, pa aplikaciju ubuduće otvarajte s
          početnog zaslona.
        </Korak>
      </ol>

      <p className="text-[var(--color-muted-foreground)]">
        Do tada sate možete unositi dok ima mreže, ali se ne spremaju na
        telefon.
      </p>
    </section>
  );
}

function Korak({
  broj,
  children,
}: {
  broj: number;
  children: React.ReactNode;
}) {
  return (
    <li className="flex items-start gap-3">
      {/* 32px and centred rather than a list marker: the numbers have to stay
          legible next to 52px controls in daylight. */}
      <span
        aria-hidden="true"
        className="broj flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)] font-bold text-[var(--color-primary-foreground)]"
      >
        {broj}
      </span>
      <span className="pt-1">{children}</span>
    </li>
  );
}
